import { createFileRoute } from "@tanstack/react-router";
import { LiderFormPage } from "@/features/sys-premiowy/lider-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/lider/nowy")({
	component: LiderFormPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-lider",
			location.pathname,
		);
	},
});
